import { css } from 'aphrodite';
import { IBio } from 'models';
import React, { FC, useRef, useState } from 'react';
import { checkIfTrue } from 'util/helpers';
import { LeftArrowIcon, RightArrowIcon } from 'util/icons';
import { Bio } from '../Bio';
import { style } from './style';

interface Props {
  bios: IBio[];
}

export const BioPagination: FC<Props> = ({ bios = [] }) => {
  const styles = style();
  const [page, setPage] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const bioContainerRef = useRef<HTMLDivElement>(null);

  const getMainSpeakerBios = (bios: IBio[]): IBio[] => {
    return bios.filter((bio) => !bio.guest_speaker || !checkIfTrue(bio.guest_speaker));
  };

  const getGuestSpeakerBios = (bios: IBio[]): IBio[] => {
    return bios.filter((bio) => bio.guest_speaker && checkIfTrue(bio.guest_speaker));
  };

  const mainSpeakerBios = getMainSpeakerBios(bios);
  const guestSpeakerBios = getGuestSpeakerBios(bios);
  const maxPage: number = guestSpeakerBios.length ? mainSpeakerBios.length : mainSpeakerBios.length - 1;

  const getPageTitle = (page: number): string => {
    if (mainSpeakerBios.length === 0) return '';
    if (page === mainSpeakerBios.length && guestSpeakerBios.length) return "Guest Speaker's bio";
    return `${mainSpeakerBios[page].name}'s bio`;
  };

  const getDisplayedBio = (): JSX.Element | JSX.Element[] => {
    // if (page === bios.length) return bios && bios.map((bio, index) => <Bio key={index} data={bio} />);
    if (page < mainSpeakerBios.length) return <Bio data={mainSpeakerBios[page]} />;
    return (
      guestSpeakerBios &&
      guestSpeakerBios.map((bio, index) => {
        return (
          <div key={index}>
            <Bio data={bio} />
            {index < guestSpeakerBios.length - 1 ? <hr className={css(styles.bioSeparator)} /> : null}
          </div>
        );
      })
    );
  };

  const onPreviousButtonClick = () => {
    if ((bioContainerRef.current?.scrollTop ?? 0) > 0) bioContainerRef.current?.scrollTo(0, 0);
    if ((containerRef.current?.parentElement?.scrollTop ?? 0) > 0) containerRef.current?.parentElement?.scrollTo(0, 0);
    setPage(page - 1);
  };

  const onNextButtonClick = () => {
    if ((bioContainerRef.current?.scrollTop ?? 0) > 0) bioContainerRef.current?.scrollTo(0, 0);
    if ((containerRef.current?.parentElement?.scrollTop ?? 0) > 0) containerRef.current?.parentElement?.scrollTo(0, 0);
    setPage(page + 1);
  };

  return (
    <div ref={containerRef} className={css(styles.container)}>
      <div ref={bioContainerRef} className={css(styles.bioContainer)}>
        {getDisplayedBio()}
      </div>
      <div className={css(styles.navigationContainer)}>
        {page > 0 ? (
          <button onClick={() => onPreviousButtonClick()} className={css(styles.button, styles.previousButton)}>
            <LeftArrowIcon /> {getPageTitle(page - 1)}
          </button>
        ) : null}
        {page < maxPage ? (
          <button onClick={() => onNextButtonClick()} className={css(styles.button, styles.nextButton)}>
            {getPageTitle(page + 1)} <RightArrowIcon />
          </button>
        ) : null}
      </div>
    </div>
  );
};
